import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NormalHomepage"] */ "/app/packages/core/src/components/homepage/NormalHomepage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/admin/AdminSettingsClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminSidebar"] */ "/app/packages/shell/src/components/admin/AdminSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/auth/RegisterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/app/packages/shell/src/components/auth/SignInForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/defaults/DefaultErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/defaults/DefaultSessionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/defaults/DefaultSessionTimeout.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/ErrorPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/GlobalErrorPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/homepage/RegistrationCodeInput.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/ModuleAdminPageLoader.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/ModulePageLoader.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/shell/src/components/NotFoundPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSlots"] */ "/app/packages/shell/src/components/SlotsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopBarCenterContentProvider","useTopBarCenterContent"] */ "/app/packages/shell/src/components/TopBarCenterContentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppFooter"] */ "/app/src/components/AppFooter.tsx");
